<template>
	<!-- 自定义报表导出进入页 -->
	<div class="container">
		<div class="top">
			<div class="head">
				<div class="title">
					自定义报表导出
				</div><!-- title -->
			</div><!-- head -->
			<div class="section" style="display:inline-block;">
				<div class="title">请选择您要输出的报表维度</div>
				<div class="parent_box">
					<div :class="'item ' + (type.p_index === index && 'active')" v-for="(item,index) in type.option"
						:key="index" @click="parent_change(item,index)">
						<div class="left">
							<img class="icon"
								:src="item.icon.indexOf('http') > -1 ? item.icon : require('../../assets/img/modify_report/' + item.icon + '.png')">
						</div>
						<div class="right">{{item.title}}</div>
						<img class="checked" src="../../assets/img/gg.png">
					</div><!-- item -->
				</div><!-- parent_box -->
			</div><!-- section -->
			<div class="section">
				<div class="title">请选择导出表格内容</div>
				<div class="type_box">
					<a-radio-group v-model:value="type.c_value" @change="type_change">
						<a-radio v-for="(item,index) in type.option[type.p_index].children" :key="index"
							:value="item">{{item.title}}</a-radio>
					</a-radio-group>
				</div><!-- type_box -->
			</div><!-- section -->
		</div><!-- top -->
		<!--   -->
		<TableList @get_select_value='get_select_value' @get_select_value_tr='get_select_value_tr' :rowKey="rowKey"
			@list_after="list_after" @screen_columns_ok='screen_columns_ok'
			@expandedRowsChange='expandedRowsChange($event)' class="table_list" :slot_table_list="slot_table_list"
			:columns.sync="type.c_value.children" :cate_list.sync="type.c_value.cate_list"
			:get_table_list="this.get_table_list" :form_data_seo="form_data_seo" ref="list" @changeStatus='changeStatus'
			:columns_setting_show="type.c_value.value == 'competing_rate_dap' ? false : true"
			:is_created_get_list="false" :is_page="(type.c_value.value == 'competing_rate_dap') ? false : true"
			:default_screen_all_checked="false" :submit_preprocessing="type.c_value.submit_preprocessing"
			:scroll="{x:true}">
			<template v-for="(vo,index) in slot_table_list" :slot="vo" slot-scope="data">
				<span v-if="type.c_value.value == 'competing_rate_dap'">{{getIsNum(data.record[vo])}}</span>
				<span v-if="type.c_value.value == 'competing_rate_user'">
					<span>{{getIsNum(data.record[vo])}}</span>
				</span>
				<div v-if="type.c_value.value == 'custom_cost_contract'" style="width:350px;">
					<template v-if='data.record.type_id==57||data.record.type_id==58'>
						<template v-for='(it,index) in goods_check'>
							<p v-if='it=="storefront"'>
								<a-checkbox disabled :checked="getInfo(data).indexOf(it)>-1?true:false">
								</a-checkbox>门店店招广告（该广告内容是否包含乙方店铺名称：
								{{data.record.require_data[getInfo(data).indexOf(it)].num==1?'是':'否)'}}，
								店铺名称为：
								<span
									v-if='data.record.require_data[getInfo(data).indexOf(it)].num==1'>{{getInfo(data).indexOf(it)>-1?data.record.require_data[getInfo(data).indexOf(it)].require:''}}
									）； </span>

							</p>
							<p v-if='it=="banner"'>
								<a-checkbox disabled :checked="getInfo(data).indexOf(it)>-1?true:false">
								</a-checkbox>门头横幅广告；
							</p>
							<p v-if='it=="standingDoorplate"'>
								<a-checkbox disabled :checked="getInfo(data).indexOf(it)>-1?true:false">
								</a-checkbox>门落地立牌广告；
							</p>
							<p v-if='it=="other"'>
								<a-checkbox disabled :checked="getInfo(data).indexOf(it)>-1?true:false">
								</a-checkbox>其他：
								<span>{{getInfo(data).indexOf(it)>-1?data.record.require_data[getInfo(data).indexOf(it)].require:''}}；
								</span>
							</p>
						</template>

					</template>
					<template v-else>
						<div v-for='item in data.record[vo]'>
							<p><span
									style='color:#000;'>{{(item.type == 'region' ? '位置' : item.type == 'sales' ? '销量' : '数量') + '要求'}}</span>
							</p>
							<p> {{item.goods_title}}&nbsp;<span v-if="item.num"> x{{ item.num }}</span><span>
									{{ item.require }}</span></p>
						</div>
					</template>
				</div>
				<div v-if="type.c_value.value == 'custom_visit_area'">
					<div v-if='vo=="customer_num"'>
						<template v-if='data.record.customer_num&&data.record.customer_num.length>0'>
							<p v-for='it in data.record.customer_num'>{{it}}</p>
						</template>
						<template v-else>
							<p>无</p>
						</template>
					</div>



					<div v-if='vo=="town"'>
						<template v-if='data.record.town&&data.record.town.length>0'>
							<p v-for='it in data.record.town'>{{it}}</p>
						</template>
						<template v-else>
							<p>无</p>
						</template>
					</div>
					<div v-if='vo=="area"'>
						<template v-if='data.record.area&&data.record.area.length>0'>
							<p v-for='it in data.record.area'>{{it}}</p>
						</template>
						<template v-else>
							<p>无</p>
						</template>
					</div>
					<div v-if='vo=="town_num"'>
						<template v-if='data.record.town_num&&data.record.town_num.length>0'>
							<p v-for='it in data.record.town_num'>{{it}}</p>
						</template>
						<template v-else>
							<p>无</p>
						</template>
					</div>

				</div>


				<div v-if="type.c_value.value == 'custom_customer_list'">

					<div v-if='vo=="cycle_barrel_brand_count"'>
						<template>
							<p @click='cycle_barrel_fun(data.record)'
								:style="data.record.cycle_barrel_brand_count >  0 ? 'color:#108ee9;' : ''">
								{{data.record.cycle_barrel_brand_count}}</p>
						</template>

					</div>

					<div v-if='vo=="cycle_barrel"'>
						<template>
							<p>{{data.record.cycle_barrel==1?'是':'否'}}</p>
						</template>

					</div>


				</div>
				<div v-if="type.c_value.value == 'custom_visit_list'">

					<div v-if='vo=="cycle_barrel_brand_count"'>
						<template>
							<p @click='cycle_barrel_fun(data.record)'
								:style="data.record.cycle_barrel_brand_count >  0 ? 'color:#108ee9;' : ''">
								{{data.record.cycle_barrel_brand_count}}</p>
						</template>

					</div>




				</div>


				<div v-if="type.c_value.value == 'custom_cost_piles'">
					<a v-if='data.record[vo]>0' @click='go_cost_info(data.record,vo)'>
						{{data.record[vo]}} </a>
					<span v-else>{{data.record[vo]}}</span>
				</div>

			</template>
			<template slot="right_btn">
				<a-popconfirm title="您确定要导出该报表吗？" ok-text="确认" cancel-text="取消" @confirm="export_excel">
					<a-button class="a_btn">导出</a-button>
				</a-popconfirm>
			</template>
			<template slot="left_btn">
				<div class="now_dir">
					<div>
						{{`已选择：${type.option[type.p_index].title}/${type.c_value.title}`}}
					</div>

					<div v-if="type.c_value.value=='custom_cost_piles'" class='custom_cost_piles_box'>

						<span class='custom_cost_piles_item'>
							客户数量：<span>{{custom_cost_piles_count.customer_num}}</span>

						</span>
						<span class='custom_cost_piles_item custom_cost_piles_item2'>
							堆箱家数：<span>
								{{custom_cost_piles_count.piles_customer}}</span>

						</span>
						<span class='custom_cost_piles_item custom_cost_piles_item3'>
							未堆箱家数：<span>{{custom_cost_piles_count.none_piles_customer}}</span>

						</span>
					</div>

				</div>

			</template>
		</TableList>



		<a-modal title="循环桶品牌" width='50%' :maskClosable='true' :visible="brand_visible" @cancel='brand_visible=false'
			@ok='brand_visible=false'>
			<div>
				<a-descriptions :column='2'>
					<a-descriptions-item label="客户名称">
						{{brand_visible_info.customer_name}}
					</a-descriptions-item>
					<a-descriptions-item label="客户类型">
						{{brand_visible_info.customer_type}}
					</a-descriptions-item>
					<a-descriptions-item label="最后拜访时间">
						{{brand_visible_info.last_visit}}
					</a-descriptions-item>
					<a-descriptions-item label="是否有循环桶">
						{{brand_visible_info.cycle_barrel==1?'是':'否'}}
					</a-descriptions-item>
					<a-descriptions-item :span="2" label="客户地址">
						{{brand_visible_info.address}}
					</a-descriptions-item>

					<a-descriptions-item span="2">
						<a-row>
							<a-col :span="8" v-for="it in brand_visible_info.cycle_barrel_brand_list">
								<a-checkbox disabled :checked='it.checked' :value="it.id">{{it.name}}</a-checkbox>
								<p class='other_info' v-if='it.id=="other"&&it.checked'>

									{{it.value}}
								</p>
							</a-col>
						</a-row>
					</a-descriptions-item>

				</a-descriptions>




			</div>
		</a-modal>

	</div>
</template>

<script>
	import {
		terminalReportSubV2
	} from "@/api/goods";
	import EditPop from "@/components/EditPop";
	import type_data from './json/modify_report.js';
	import TableList from "@/components/TableList";
	import {
		getList,
		getList2,
		exportTable
	} from '@/api/re'
	import {
		getApprovalTypeSelect
	} from "@/api/evection";
	import {
		goodsCate,
		headGoodsCate
	} from "@/api/goods";
	import {
		getType
	} from '@/api/approval';
	import {
		getCostType
	} from "@/api/cost";
	import mapping from './json/mapping_search.json';
	import {
		getSeasonSelect
	} from "@/api/supervision";
	export default {
		components: {
			TableList,
			EditPop
		},
		data() {
			return {
				brand_visible: false,
				brand_visible_info: {
					cycle_barrel_brand_list: []
				},
				form_data_visit: {
					title: '循环桶品牌',
					item_margin_bottom: '8px',
					layout: 'horizontal',
					list: [{
							type: 'slot',
							name: 'customer',
							title: '名称',
							options: {},
						},
						{
							type: 'slot',
							name: 'group',
							title: '客户类型',

						},
						{
							type: 'slot',
							name: 'arrive_time',
							title: '拜访时间',
						},
						{
							type: 'slot',
							name: 'cycle_barrel',
							title: '是否有循环桶',
						},
						{
							type: 'slot',
							name: 'address',
							title: '客户地址',
						},

						{
							type: "slot",
							name: "cycle_barrel_brand_list",
							title: "品牌",
							options: {
								initialValue: []
							},
							list: [],
						},

					]
				},
				goods_check: ['storefront', 'banner', 'standingDoorplate', 'other'],
				goods_temp: [],
				custom_cost_piles_count: {
					customer_num: 0,
					piles_customer: 0,
					none_piles_customer: 0
				},
				competing_rate_dap: {
					fixed_selected_list: ["name", "customer_num", "total", ],
					fixed_list: [{
							dataIndex: "name",
							title: "名称",
							// fixed: 'left',
							cate_name: "人员字段",
							width: '300px',
						},
						{
							dataIndex: "customer_type",
							title: "客户类型",
							cate_name: "客户字段",
							width: '150px'
						},
						{
							dataIndex: "region_type",
							title: "城乡类型",
							cate_name: "客户字段",
							width: '100px'

						},
						{
							title: "客户数",
							cate_name: "客户字段",
							// fixed: 'left',
							width: '200px',
							dataIndex: "customer_num",

						},


						{
							title: '总数 | 铺市率',
							dataIndex: "total",
							// fixed: 'left',
							width: '200px',
							scopedSlots: {
								customRender: "total"
							}
						},
					],
				},
				competing_rate_user: {
					fixed_selected_list: ["name", "customer_num", "total", ],
					fixed_list: [{
							dataIndex: "name",
							title: "名称",
							width: '200px',
							// fixed: 'left',
							cate_name: "人员字段"
						},
						{
							dataIndex: "uid",
							title: "人员ID",
							width: '150px',
							cate_name: "人员字段"
						},

						{
							dataIndex: "department",
							title: "部门",
							width: '150px',
							cate_name: "人员字段"
						},
						{
							dataIndex: "role",
							title: "职务",
							width: '150px',
							cate_name: "人员字段"
						},
						{
							dataIndex: "rule",
							title: "角色",
							width: '150px',
							cate_name: "人员字段"
						},
						{
							dataIndex: "user_status",
							title: "在职状态",
							width: '150px',
							cate_name: "人员字段"
						},
						{
							dataIndex: "is_leader",
							title: "是否部门领导",
							width: '150px',
							cate_name: "人员字段"
						},
						{
							dataIndex: "is_admin",
							title: "是否管理员",
							width: '150px',
							cate_name: "人员字段"
						},
						{
							dataIndex: "customer_type",
							title: "客户类型",
							cate_name: "客户字段",
							width: '150px'

						},
						{
							dataIndex: "region_type",
							title: "城乡类型",
							cate_name: "客户字段",
							width: '100px'

						},
						{
							title: "客户数",
							cate_name: "客户字段",
							width: '200px',
							// fixed: 'left',
							dataIndex: "customer_num",
						},
						{
							title: '总数 | 铺市率',
							dataIndex: "total",
							width: '200px',
							scopedSlots: {
								customRender: "total"
							}
						},
					],
				},
				customer_sales_volume: {
					fixed_selected_list: ["username", "role_name", 'department_name', 'user_status', 'customer_id',
						'customer_name', 'customer_type', 'region_type', 'customer_status', 'receipt_number',
						'receipt_goods_number'
					],
					fixed_list: [{
							dataIndex: "username",
							title: "姓名",
							cate_name: "人员字段",
							width: '150px'
						},
						{
							dataIndex: "role_name",
							title: "岗位",
							cate_name: "人员字段",
							width: '150px'
						},
						{
							dataIndex: "department_name",
							title: "所属部门",
							cate_name: "人员字段",
							width: '200px'
						},
						{
							dataIndex: "user_status",
							title: "在职状态",
							cate_name: "人员字段",
							width: '100px'
						},
						{
							dataIndex: "customer_id",
							title: "客户ID",
							cate_name: "客户字段",
							width: '100px'
						},
						{
							dataIndex: "customer_name",
							title: "客户名称",
							cate_name: "客户字段",
							width: '200px'
						},
						{
							dataIndex: "customer_type",
							title: "客户类型",
							cate_name: "客户字段",
							width: '100px'
						},
						{
							dataIndex: "region_type",
							title: "城乡类型",
							cate_name: "客户字段",
							width: '100px'
						},
						{
							dataIndex: "customer_status",
							title: "运营状态",
							cate_name: "客户字段",
							width: '100px'
						},
						{
							dataIndex: "receipt_number",
							title: "回单次数",
							cate_name: "销量字段",
							width: '100px'
						},
						{
							dataIndex: "receipt_goods_number",
							title: "回单件数",
							cate_name: "销量字段",
							width: '100px'
						},
					],
				},
				customer_sales_comparison_cate: {
					fixed_selected_list: ["username", "role_name", 'department_name', 'user_status', 'customer_id',
						'customer_name', 'customer_type', 'region_type', 'customer_status'
					],
					fixed_list: [{
							dataIndex: "username",
							title: "姓名",
							cate_name: "人员字段",
							width: 150
						},
						{
							dataIndex: "role_name",
							title: "岗位",
							cate_name: "人员字段",
							width: 150
						},
						{
							dataIndex: "department_name",
							title: "所属部门",
							cate_name: "人员字段",
							width: 200
						},
						{
							dataIndex: "user_status",
							title: "在职状态",
							cate_name: "人员字段",
							width: 100
						},
						{
							dataIndex: "customer_id",
							title: "客户ID",
							cate_name: "客户字段",
							width: 100
						},
						{
							dataIndex: "customer_name",
							title: "客户名称",
							cate_name: "客户字段",
							width: 200
						},
						{
							dataIndex: "customer_type",
							title: "客户类型",
							cate_name: "客户字段",
							width: 150
						},
						{
							dataIndex: "region_type",
							title: "城乡类型",
							cate_name: "客户字段",
							width: 100
						},
						{
							dataIndex: "customer_status",
							title: "运营状态",
							cate_name: "客户字段",
							width: 100
						},
					],
				},
				goods_list: [],
				cate_list: [],
				columns: [],
				columns_list_temp: [],
				slot_table_list: ['total', 'require_data', 'one_region_num', 'two_region_num', 'three_region_num',
					'four_region_num', 'customer_num', "area", 'town_num', 'town', 'cycle_barrel_brand_count',
					'cycle_barrel'
				],
				get_table_list: getList,
				form_data_seo: {
					...this.$config.form_data_seo,
					list: [],
				},
				mapping: mapping,
				// 维度相关
				type: {
					option: type_data, // 维度类型（本地数据） 三层
					p_index: 0, // 选中了哪个维度
					c_value: {}, // 选中的表格内容 @return {label,value,children}
				},
				sales_report_key: ["customer_sales_volume", "customer_sales_comparison_cate",
					"customer_sales_comparison_goods"
				],
				// 服务于筛选表单内下拉数据的填充
				api_load: [{
						name: "department", // 需要对modif_report.js中的哪些筛选项表单进行下拉数据的填充
						loaded: false, // 当前类型的下拉数据是否加载完毕，如果为 true 就不会继续调用
						api: this.$method.get_department, // 部门
						key: "treeData", // 决定填充筛选项表单中的哪个属性
						need_load: false, // 当前“表格内容”中是否存在需要获取接口的表单项
					},
					{
						name: "role_id",
						loaded: false,
						api: this.$method.get_role_tree, //岗位职务
						key: "treeData",
						need_load: false,
					},
					// {
					// 	name:"role_id",
					// 	loaded:false,
					// 	api:this.$method.get_role, // 岗位职务
					// 	key:"list",
					// 	need_load:false,
					// },
					// {
					// 	name: "customer_level",
					// 	loaded: false,
					// 	api: this.$method.get_level, // 客户等级
					// 	key: "list",
					// 	need_load: false,
					// },
					{
						name: "grade_id",
						loaded: false,
						api: this.$method.get_level_type, // 客户等类别
						key: "list",
						need_load: false,
					},

					{
						name: "customer_type",
						loaded: false,
						api: this.$method.get_group, // 客户类型
						key: "treeData",
						need_load: false,
					},
					{
						name: "region_type",
						loaded: false,
						api: this.$method.get_RegionType, // 客户类型
						key: "list",
						need_load: false,
					},
					{
						name: "distributor_type",
						loaded: false,
						api: this.$method.get_group, // 经销商类型
						key: "treeData",
						need_load: false,
					},
					{
						name: "cycle_barrel_brand",
						loaded: false,
						api: this.$method.getCycleBarrel, // 经销商类型
						key: "list",
						need_load: false,
					},
					{
						name: "approval_type",
						loaded: false,
						api: getApprovalTypeSelect, // 差旅审批类型
						key: "list",
						need_load: false,
					},
					{
						name: "cate_id",
						loaded: false,
						api: goodsCate, // 商品分类
						key: "treeData",
						need_load: false,
					},
					{
						name: "launch_type",
						loaded: false,
						api: getCostType,
						key: "treeData",
						need_load: false,
					},
					// {
					// 	name:"launch_type",
					// 	loaded:false,
					// 	api:getType, // 获取合约类型
					// 	key:"list",
					// 	need_load:false,
					// 	param:{type: 'investment'}, // 需要传入接口的值
					// },
					{
						name: "goods_id",
						loaded: false,
						api: this.$method.get_goods, // 获取品项
						key: "list",
						need_load: false,
					},
					{
						name: "busy_season_status",
						loaded: false,
						api: getSeasonSelect,
						key: "list",
						need_load: false,
					},
				],
			}
		},
		created() {
			this.first_load();
		},
		computed: {
			rowKey() {
				if (this.type.c_value.value == 'custom_visit_user' || this.type.c_value.value == "custom_visit_list" ||
					this.type.c_value.value == "custom_customer_list" || this.type.c_value.value == "custom_stock_report"
				) {
					return 'customer_id'
				} else if (this.type.c_value.value == 'custom_visit_customer' || this.type.c_value.value ==
					"custom_freezer_list") {
					return 'customer_id'
				} else if (this.type.c_value.value == 'custom_trip_report') {
					return 'user_id'
				} else if (this.type.c_value.value == 'custom_trip_order') {
					return 'hotel_id'
				} else if (this.type.c_value.value == 'custom_trip_order') {
					return 'hotel_id'
				} else if (this.type.c_value.value == 'competing_rate_user') {
					return 'phone'
				} else {
					return 'id'
				}
			},

		},
		unmounted() {},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.get_column
			});
		},
		methods: {
			cycle_barrel_fun(data) {
				if (data.cycle_barrel_brand_count == 0) {
					return false;
				}
				this.brand_visible = true
				this.brand_visible_info = data
			},
			getInfo(data) {
				return data.record.require_data.map(it => {
					return it.type
				})
			},
			go_cost_info(info, type) {
				let num = 0
				if (type == 'one_region_num') {
					num = 1
				}
				if (type == 'two_region_num') {
					num = 2
				}
				if (type == 'three_region_num') {
					num = 3
				}
				if (type == 'four_region_num') {
					num = 4
				}
				let list = this.$refs.list;

				type_data.forEach(it => {
					it.children.forEach(i => {
						if (i.value == 'custom_cost_launch') {
							this.type.c_value = i
							this.type.c_value.form_list.forEach(form_it => {
								if (form_it.name == 'approval_status') {
									form_it.options.initialValue = '2'
								}
								if (form_it.name == 'region_time') {
									if (list.seo_data.end_time) {
										form_it.options.initialValue = this.$moment(
											new Date(list
												.seo_data.end_time)).format(
											'YYYY-MM-DD')
									} else {
										form_it.options.initialValue = this.$moment(
												new Date())
											.format('YYYY-MM-DD')
									}
								}

								if (form_it.name == 'region_nums') {
									form_it.options.initialValue = num
								}
								if (form_it.name == 'uid') {
									form_it.options.initialValue = info.id
								}
							})

							this.set_list_new(info, num, list.seo_data.end_time ? list.seo_data
								.end_time :
								this.$moment(new Date()).format('YYYY-MM-DD'))
						}
					})
				})
			},
			set_list_new(info, num, time) {
				this.options_load()

				let list = this.$refs.list;
				// 将筛选项表单中已经填写的值全部清空
				list.$refs.form_seo.form.resetFields();
				let obj = {
					uid: info.id,
					region_nums: num,
					region_time: time,
					approval_status: '2',
					launch_type: '30',
					end_time: undefined
				}
				list.seo_data = obj;
				list.setFieldsValue(Object.assign({}, obj))
				// 选中了哪个维度，传给后端
				list.fixed_seo_data.export_type = this.type.c_value.value;
				// 设置“字段设置”弹窗中默认选中哪些选项
				list.fixed_seo_data.field = this.type.c_value.selected_field.toString(); // 传给后端
				list.screen_columns.checked = this.type.c_value.selected_field; // 在“字段设置”弹窗中回显
				// 设置筛选表单中的筛选项
				this.form_data_seo.list = this.type.c_value.form_list
				this.form_data_seo.list.forEach(item => {
					if (item.name == 'launch_type') {
						item.options.initialValue = [30]
					}
				})
				list.pagination.current = 1
				list.pagination.page = 1
				// 将列表中的“列”与现在设置的“字段设置”同步
				setTimeout(() => {
					list.set_columns();
				}, 1);
				// 该延时器用于覆盖 TableList 组件里 watch 中 columns 对 real_columns 的更新

				list.page = 1; // 切换维度后需要重新从第一页开始
				list.get_list();
			},
			get_select_value_tr(e) {

				if (e.label == 'cycle_barrel') {
					this.form_data_seo.list.forEach(it => {
						if (it.name == 'cycle_barrel_brand') {
							it.hidden = e.value == 1 ? false : true;
						}
					})

				}

			},
			get_select_value(e) {
				if (this.type.c_value.value == 'custom_cost_launch') {
					if (e == 2 || e == -1) {
						this.form_data_seo.list[9].hidden = false
					} else {
						this.form_data_seo.list[9].hidden = true
					}
				}
			},
			changeStatus(e) {
				if (this.type.p_index == 5) {
					this.res_column(e)
				}
				if (this.type.p_index == 7) {
					this.sales_column(e)
				}
				if (this.type.p_index == 4) {
					type_data.forEach(it => {
						it.children.forEach(i => {
							if (i.value == 'custom_cost_launch') {
								this.type.c_value.form_list.forEach(item => {
									if (item.options && item.options.initialValue) {
										item.options.initialValue = null
									}
								})
							}
						})
					})
				}
			},
			sales_column(e) {
				if (this.type.c_value.value == 'customer_sales_volume') {
					type_data[7].children[0].children = JSON.parse(JSON.stringify(this.customer_sales_volume
						.fixed_list))
					type_data[7].children[0].selected_field = JSON.parse(JSON.stringify(this.customer_sales_volume
						.fixed_selected_list))
					this.slot_table_list = []
					this.getGoodsHead(e ? e.goods_id : '')
				} else if (this.type.c_value.value == 'customer_sales_comparison_goods') {
					type_data[7].children[2].children = JSON.parse(JSON.stringify(this
						.customer_sales_comparison_cate
						.fixed_list))
					type_data[7].children[2].selected_field = JSON.parse(JSON.stringify(this
						.customer_sales_comparison_cate
						.fixed_selected_list))
					this.getSalesHead(e ? e.goods_id : '', e ? e.start_time : '', e ? e.end_time : '')
				} else {
					type_data[7].children[1].children = JSON.parse(JSON.stringify(this
						.customer_sales_comparison_cate
						.fixed_list))
					type_data[7].children[1].selected_field = JSON.parse(JSON.stringify(this
						.customer_sales_comparison_cate
						.fixed_selected_list))
					this.getCateHead(e ? e.cate_id : '', e ? e.start_time : '', e ? e.end_time : '')
				}
			},
			getGoodsHead(goods_id) {
				this.$method.get_goods_v2({
					data: {
						goods_ids: goods_id ? goods_id : null,
						search_type: 'sales'
					}
				}).then(res => {
					this.goods_list = res.data.list;
					res.data.list.forEach(item => {
						this.slot_table_list.push('goods_' + item.id)
						let obj = {
							title: item.goods_title,
							dataIndex: 'goods_' + item.id,
							cate_name: "none",
							width: 150
						}
						type_data[7].is_more = true
						type_data[7].children[0].children.push(obj)
						type_data[7].children[2].children.push(obj)
						type_data[7].children[2].selected_field.push('goods_' + item.id)
						type_data[7].children[0].selected_field.push('goods_' + item.id)
					})
				})
			},
			getSalesHead(goods_id, start_time, end_time) {
				this.$method.get_goods_v2({
					data: {
						goods_ids: goods_id ? goods_id : null,
						start_time: start_time ? start_time : null,
						end_time: end_time ? end_time : null,
						search_type: 'sales_goods'
					}
				}).then(res => {
					this.goods_list = res.data.list;
					this.slot_table_list.push('date_range')
					this.slot_table_list.push('last_year')
					let warp_width = (150 * res.data.list.length) + 100
					let date_range = {
						title: res.data.time_range,
						dataIndex: 'date_range',
						cate_name: "销量字段",
						width: warp_width,
						customHeaderCell: function() {
							return {
								style: {
									borderColor: '#eee',
									borderWidth: '0 1px 1px 1px',
									borderStyle: 'solid',
								},
							};
						},
						children: []
					}
					let last_year = {
						title: '去年同期',
						dataIndex: 'last_year',
						cate_name: "销量字段",
						width: warp_width,
						customHeaderCell: function() {
							return {
								style: {
									borderColor: '#eee',
									borderWidth: '0 1px 1px 1px',
									borderStyle: 'solid',
								},
							};
						},
						children: []
					}
					res.data.list.forEach(item => {
						let item_now = {
							title: item.goods_title,
							cate_name: "销量字段",
							dataIndex: "now_" + item.id,
							width: 150,
							align: "center",
							customHeaderCell: function() {
								return {
									style: {
										borderColor: '#eee',
										borderWidth: '0 1px 1px 1px',
										borderStyle: 'solid',
									},
								};
							},
						}
						date_range.children.push(item_now)
						let item_last = {
							title: item.goods_title,
							cate_name: "销量字段",
							dataIndex: "last_" + item.id,
							width: 150,
							align: "center",
							customHeaderCell: function() {
								return {
									style: {
										borderColor: '#eee',
										borderWidth: '0 1px 1px 1px',
										borderStyle: 'solid',
									},
								};
							},
						}
						last_year.children.push(item_last)
					})
					let subtotal = {
						title: '小计',
						dataIndex: "now_total",
						cate_name: "销量字段",
						width: 100,
						align: "center",
						customHeaderCell: function() {
							return {
								style: {
									borderColor: '#eee',
									borderWidth: '0 1px 1px 1px',
									borderStyle: 'solid',
								},
							};
						},
					}
					date_range.children.push(subtotal)
					let last_total = {
						title: '小计',
						dataIndex: "last_total",
						cate_name: "销量字段",
						width: 100,
						align: "center",
						customHeaderCell: function() {
							return {
								style: {
									borderColor: '#eee',
									borderWidth: '0 1px 1px 1px',
									borderStyle: 'solid',
								},
							};
						},
					}
					last_year.children.push(last_total)
					type_data[7].children[2].children.push(date_range)
					type_data[7].children[2].children.push(last_year)
					type_data[7].children[2].children.push({
						title: "差异",
						dataIndex: 'difference',
						cate_name: '销量字段',
						align: "center",
						width: 100
					})
					type_data[7].is_more = true
					type_data[7].children[2].selected_field.push('date_range')
					type_data[7].children[2].selected_field.push('last_year')
					type_data[7].children[2].selected_field.push('difference')
				})
			},
			getCateHead(cate_id, start_time, end_time) {
				headGoodsCate({
					data: {
						cate_id: cate_id ? cate_id : null,
						start_time: start_time ? start_time : null,
						end_time: end_time ? end_time : null
					}
				}).then(res => {
					this.cate_list = res.data.list;
					this.slot_table_list.push('date_range')
					this.slot_table_list.push('last_year')
					let date_range = {
						title: res.data.time_range,
						dataIndex: 'date_range',
						cate_name: "销量字段",
						width: res.data.width,
						customHeaderCell: function() {
							return {
								style: {
									borderColor: '#eee',
									borderWidth: '0 1px 1px 1px',
									borderStyle: 'solid',
								},
							};
						},
						children: []
					}
					let last_year = {
						title: '去年同期',
						dataIndex: 'last_year',
						cate_name: "销量字段",
						width: res.data.width,
						customHeaderCell: function() {
							return {
								style: {
									borderColor: '#eee',
									borderWidth: '0 1px 1px 1px',
									borderStyle: 'solid',
								},
							};
						},
						children: []
					}
					res.data.list.forEach(item => {
						let item_now = {
							title: item.cate_title,
							cate_name: "销量字段",
							dataIndex: "now_" + item.id,
							width: 100,
							align: "center",
							customHeaderCell: function() {
								return {
									style: {
										borderColor: '#eee',
										borderWidth: '0 1px 1px 1px',
										borderStyle: 'solid',
									},
								};
							},
						}
						date_range.children.push(item_now)
						let item_last = {
							title: item.cate_title,
							cate_name: "销量字段",
							dataIndex: "last_" + item.id,
							width: 100,
							align: "center",
							customHeaderCell: function() {
								return {
									style: {
										borderColor: '#eee',
										borderWidth: '0 1px 1px 1px',
										borderStyle: 'solid',
									},
								};
							},
						}
						last_year.children.push(item_last)
					})
					let subtotal = {
						title: '小计',
						dataIndex: "now_total",
						cate_name: "销量字段",
						width: 100,
						align: "center",
						customHeaderCell: function() {
							return {
								style: {
									borderColor: '#eee',
									borderWidth: '0 1px 1px 1px',
									borderStyle: 'solid',
								},
							};
						},
					}
					date_range.children.push(subtotal)
					let last_total = {
						title: '小计',
						dataIndex: "last_total",
						cate_name: "销量字段",
						width: 100,
						align: "center",
						customHeaderCell: function() {
							return {
								style: {
									borderColor: '#eee',
									borderWidth: '0 1px 1px 1px',
									borderStyle: 'solid',
								},
							};
						},
					}
					last_year.children.push(last_total)
					type_data[7].children[1].children.push(date_range)
					type_data[7].children[1].children.push(last_year)
					type_data[7].children[1].children.push({
						title: "差异",
						dataIndex: 'difference',
						cate_name: '销量字段',
						align: "center",
						width: 100
					})
					type_data[7].is_more = true
					type_data[7].children[1].selected_field.push('date_range')
					type_data[7].children[1].selected_field.push('last_year')
					type_data[7].children[1].selected_field.push('difference')
				})
			},
			res_column(e) {
				type_data[5].children[0].children = JSON.parse(JSON.stringify(this.competing_rate_user.fixed_list))
				type_data[5].children[0].selected_field = JSON.parse(JSON.stringify(this.competing_rate_user
					.fixed_selected_list))
				type_data[5].children[1].children = JSON.parse(JSON.stringify(this.competing_rate_dap.fixed_list))
				type_data[5].children[1].selected_field = JSON.parse(JSON.stringify(this.competing_rate_dap
					.fixed_selected_list))
				this.slot_table_list = ['total']
				this.get_column(e ? e.goods_id : '')

			},
			getIsNum(datas, type) {

				if (datas) {
					let text = ''
					text += datas.num ? datas.num : '0'
					text += '|'
					text += datas.ratio ? datas.ratio + '%' : '0%'
					return text
				} else {
					return '0|0%';
				}
			},
			list_after(res) {

				if (this.type.p_index == 5) {
					let list = this.$refs.list.list;
					list = list.map((item, index) => {
						if (item.type == 1) {
							item.children = [];
						}

						return item;
					});
				}

				if (this.type.c_value.value == 'custom_cost_piles') {
					this.custom_cost_piles_count = res.res.data.count
				}

			},
			get_list_key(list, key, index_arr = []) {
				for (let i = 0; i < list.length; i++) {
					if (list[i].id == key) {
						return list[i]
					}

					if (Array.isArray(list[i].children) && list[i].children.length) {
						let value = this.get_list_key(list[i].children, key);
						if (value !== false) {
							return value;
						}
					}
				}

				return false;
			},
			expandedRowsChange(e) {
				if (this.type.p_index == 5) {
					e.forEach(key => {
						let list = JSON.parse(JSON.stringify(this.$refs.list.list));
						let item = this.get_list_key(list, key);
						if (!item.hasOwnProperty('is_req')) {
							terminalReportSubV2({
								data: {
									id: key,
									...this.$refs.list.seo_data
								}
							}).then(res => {

								item.children = [
									...res.data.list.map((vo) => {
										if (vo.type == 1) {
											vo.children = [];
										}

										return vo;
									})

								];
								item.is_req = true;
								this.$refs.list.set_data('list', list);
							})
						}
					});
				}
			},
			screen_columns_ok(e) {
				if (this.type.c_value.value == 'competing_rate_user') {
					this.competing_rate_user.fixed_selected_list = JSON.parse(JSON.stringify(e.checkeds))
					this.res_column(this.$refs.list.seo_data)
				} else if (this.sales_report_key.indexOf(this.type.c_value.value) !== -1) {
					this.sales_column(this.$refs.list.seo_data)
				}
			},
			/* 
			 * 导出表格
			 * 实际上导出并不在本页进行处理
			 * 由于数据体积过大，因此该接口仅作提示作用
			 * 告知用户表格已经进入导出队列，请到“运营管理/导出下载”页面查看导出状况或者进行下载
			 */
			export_excel() {
				exportTable({
					data: {
						field: this.$refs.list.fixed_seo_data.field, // 选择了哪些字段
						export_type: this.$refs.list.fixed_seo_data.export_type, // 选择了哪个维度
						...this.$refs.list.seo_data, // 筛选项表单值
					},
					info: true,
					loading: true
				})
			},
			// 页面第一次加载
			first_load() {
				this.$route.query.range_date1 = undefined;
				// 进来页面时默认选中一个维度（第一个维度下的第一个表格内容）
				if (JSON.stringify(this.$route.query) == '{}' || !this.$route.query.report_key) {
					this.type.c_value = this.type.option[this.type.p_index].children[0];
				} else {
					if (this.$route.query.report_key == "competing_rate_dap") {
						this.res_column(this.$route.query)
					}
					try {
						this.type.option.forEach(item => {
							item.children.forEach(c_item => {
								if (c_item.value == this.$route.query.report_key) {
									this.type.c_value = c_item;
									throw new Error("break");
								}
							});
							this.type.p_index = this.type.p_index + 1;
						});
					} catch (e) {

						if (e.message != "break") throw e;
					}
					if (this.sales_report_key.indexOf(this.$route.query.report_key) !== -1) {
						this.sales_column(this.$route.query)
					}
				}
				this.$nextTick(() => {
					let query = this.get_quert();
					if (query) {
						this.$refs.list.fixed_seo_data = {
							...query
						};
					}

					this.set_list_payload();
					if (query) {
						this.form_data_seo.list.forEach(item => {
							if (!item.options) {
								item.options = {}
							}
							if (item.name == "range_date") {
								if (query["start_time"] && query["end_time"]) {
									item.options.initialValue = [query['start_time'], query[
										'end_time']];
								}

							} else if (item.name == "in_date") {
								if (query["in_start_time"] && query["in_end_time"]) {
									item.options.initialValue = [query['in_start_time'], query[
										'in_end_time']];
								}
							} else if (item.name == "out_date") {
								if (query["out_start_time"] && query["out_end_time"]) {
									item.options.initialValue = [query['out_start_time'], query[
										'out_end_time']];
								}
							} else if (item.name == "address_type,address") {
								item.options1.initialValue = query.address_type;
								item.options2.initialValue = query.address;
							} else if (item.name == "time_type,range_date") {
								item.options.initialValue = [query['start_time'], query[
									'end_time']];
								item.options1.initialValue = query.time_type;
								item.start.options.initialValue = query.start_time
								item.end.options.initialValue = query.end_time
							} else {
								if (query[item.name]) {
									if (query[item.name].indexOf(",") == -1) {
										item.options.initialValue = query[item.name].toString();
									} else {
										item.options.initialValue = query[item.name].split(",");
									}
								}
							}
						});
						this.$refs.list.seo_data = query;
					} else {
						let query = {}
						this.form_data_seo.list.forEach(item => {
							if (item.type == 'date') {

								if (this.type.c_value.value ==
									'competing_rate_user' || this.type.c_value.value ==
									'competing_rate_dap' || this.type.c_value.value ==
									'competing_rate_cus' || this.type.c_value.value ==
									'custom_cost_piles' || this.type.c_value
									.value == 'custom_cost_visit_list' || this.type.c_value
									.value == 'custom_visit_area') {
									item.options.initialValue = this.$moment(new Date(),
										'YYYY-MM-DD');
									this.$refs.list.fixed_seo_data['start_time'] = this.$moment(
											new Date())
										.format('YYYY-MM-DD')
								}
							}
							if (item.type == 'month') {
								if (this.type.c_value.value ==
									'sink_frontline_month') {
									item.options.initialValue = this.$moment(new Date(),
										'YYYY-MM');
									// query[item.name] = this.$moment(new Date()).format('YYYY/MM')  
									this.$refs.list.fixed_seo_data['start_time'] = this.$moment(
											new Date())
										.format('YYYY-MM-DD')
								}
							}
							if (item.type == "range_date") {
								if (this.type.c_value.value == 'custom_visit_user' || this.type
									.c_value
									.value == 'custom_visit_customer' || this.type.c_value.value ==
									'custom_visit_list' || this.type.c_value.value ==
									'custom_order_list' || this.type.c_value.value ==
									'custom_order_distributor' || this.type.c_value.value ==
									'sink_frontline_month' || this.type.c_value.value ==
									'customer_sales_comparison_cate' || this.type.c_value.value ==
									'customer_sales_comparison_goods') {
									item.options.initialValue = [this.$moment(new Date(new Date()
												.getTime() - (30 * 24 * 60 * 60 * 1000)),
											'YYYY-MM-DD'),
										this
										.$moment(new Date(), 'YYYY-MM-DD')
									]
									this.$refs.list.fixed_seo_data['start_time'] = this.$moment(
										new Date(
											new Date()
											.getTime() - (30 * 24 * 60 * 60 * 1000))).format(
										'YYYY-MM-DD')

									this.$refs.list.fixed_seo_data['end_time'] = this.$moment(
											new Date())
										.format('YYYY-MM-DD')

								}


								if (this.type.c_value.value == 'customer_sales_volume' || this.type
									.c_value
									.value ==
									'customer_sales_comparison_goods' || this.type.c_value.value ==
									'customer_sales_comparison_cate') {
									item.options.initialValue = [this.$moment(new Date(),
											'YYYY-MM-DD'),
										this.$moment(new Date(), 'YYYY-MM-DD')
									]


									this.$refs.list.fixed_seo_data['start_time'] = this.$moment(
											new Date())
										.format('YYYY-MM-DD')
									this.$refs.list.fixed_seo_data['end_time'] = this.$moment(
											new Date())
										.format('YYYY-MM-DD')
								}


								if (this.type.c_value.value == 'custom_order_goods' || this.type
									.c_value
									.value == 'custom_order_checkout') {
									// 获取当前月份第一天
									const firstDay = new Date();
									firstDay.setDate(1);
									// 获取当前月份最后一天
									const lastDay = new Date();
									item.options.initialValue = [this.$moment(firstDay,
											'YYYY-MM-DD'),
										this.$moment(lastDay, 'YYYY-MM-DD')
									]

									this.$refs.list.fixed_seo_data['start_time'] = this.$moment(
											firstDay)
										.format('YYYY-MM-DD')
									this.$refs.list.fixed_seo_data['end_time'] = this.$moment(
											new Date())
										.format('YYYY-MM-DD')
								}

							}
						})

					}
				})
			},
			// 根据当前选中的“表格内容”对筛选表单内的下拉数据进行填充
			options_load() {
				// 当前筛选表单内有哪些需要在本次获取下拉数据
				this.type.c_value.form_list.map(option => {
					this.api_load.map(item => {
						if (option.name === item.name) {
							item.need_load = true; // 如果当前“表格内容”的筛选表单项和 api_load 中对得上就允许它在接下来进行请求
						}
					})
				})

				this.api_load.map(item => {
					/**
					 * 只有该类型的数据没有加载才会请求接口
					 * loaded 和 need_load是有区别的，loaded 优先级远大于 need_load
					 * loaded 代表该接口是否已经加载完毕了
					 * need_load 则是告知当前“表格内容”中是否存在需要请求下拉数据接口的表单项
					 */
					if (!item.loaded && item.need_load) {
						item.api.call(this.$method, {
							data: item.param
						}).then(res => {
							let data = res;
							// 在该判断内的 name 都需要对数据进行额外的转换才能正常使用
							if (item.name === "approval_type") {
								// 差旅审批类型
								data = res.data.list.map(item => {
									return {
										value: item.label,
										key: item.value.toString()
									}
								})
							} else if (item.name === "launch_type") {
								// 获取合约类型
								// data = res.data.list.map(item=>{return {value:item.name,key:item.id.toString()}})
								data = res.data.list
							} else if (item.name === "cate_id") {
								data = res.data.list
							} else if (item.name === "busy_season_status") {
								data = res.data.list.map(it => {
									return {
										key: it.value.toString(),
										value: it.label,
									}
								})
							} else if (item.key != "treeData") {
								data = res.map(item => {
									return {
										value: item.value,
										key: item.key.toString()
									}
								})
							}
							// 将获取到的数据填充进筛选项表单的下拉列表中
							this.set_form_item_option({
								name: item.name,
								key: item.key,
								res: data
							});
							item.loaded = true; // 已经加载完毕了，就不需要进行加载了
						});
					}

					item.need_load = false; // 将存在状态重置
				})
			},
			// 填充筛选项表单中的下拉数据
			set_form_item_option({
				name = '',
				key = '',
				res
			}) {
				this.type.option.map(item => {
					item.children.map(child => {
						child.form_list && child.form_list.map(form_item => {
							if (form_item.name === name) {
								form_item[key] = res;
							}
						})
					})
				})
			},
			// 更新当前页面的显示字段并且调取一次列表
			set_list_payload() {
				let list = this.$refs.list;
				// 将筛选项表单中已经填写的值全部清空
				list.seo_data = {};
				// 在UI层面将筛选表单内容清空，避免切换至其他维度时污染同 name 的表单项
				list.$refs.form_seo.form.resetFields();
				// 选中了哪个维度，传给后端
				list.fixed_seo_data.export_type = this.type.c_value.value;
				// 设置“字段设置”弹窗中默认选中哪些选项
				list.fixed_seo_data.field = this.type.c_value.selected_field.toString(); // 传给后端
				list.screen_columns.checked = this.type.c_value.selected_field; // 在“字段设置”弹窗中回显
				// 设置筛选表单中的筛选项
				this.form_data_seo.list = this.type.c_value.form_list
				if (list.pagination) {
					list.pagination.current = 1
					list.pagination.page = 1
				}

				this.form_data_seo.list.forEach(item => {
					if (item.options) {
						item.options.initialValue = undefined;
					}
					if (!this.$route.query.report_key || this.$route.query.report_key != this.type.c_value
						.value) {

						if (item.type == 'date') {
							if (this.type.c_value.value ==
								'competing_rate_user' || this.type.c_value.value ==
								'competing_rate_dap' || this.type.c_value.value ==
								'competing_rate_cus' || this.type.c_value.value == 'custom_cost_piles' ||
								this.type
								.c_value
								.value == 'custom_cost_visit_list' || this.type.c_value.value ==
								'custom_visit_area') {
								item.options.initialValue = this.$moment(new Date(), 'YYYY-MM-DD')
								list.fixed_seo_data['start_time'] = this.$moment(new Date()).format(
									'YYYY-MM-DD')
							}
						}
						if (item.type == 'month') {
							if (this.type.c_value.value ==
								'sink_frontline_month') {
								item.options.initialValue = this.$moment(new Date(), 'YYYY-MM')

								list.fixed_seo_data['start_time'] = this.$moment(new Date()).format(
									'YYYY-MM-DD')
							}

						}


						if (item.type == "range_date") {
							if (this.type.c_value.value == 'custom_visit_user' || this.type.c_value
								.value == 'custom_visit_customer' || this.type.c_value.value ==
								'custom_visit_list' || this.type.c_value.value ==
								'custom_order_list' || this.type.c_value.value ==
								'custom_order_distributor' || this.type.c_value.value ==
								'sink_frontline_month' || this.type.c_value.value ==
								'customer_sales_comparison_cate' || this.type.c_value.value ==
								'customer_sales_comparison_goods') {
								item.options.initialValue = [this.$moment(new Date(new Date()
										.getTime() - (30 * 24 * 60 * 60 * 1000)), 'YYYY-MM-DD'),
									this
									.$moment(new Date(), 'YYYY-MM-DD')
								]
								list.fixed_seo_data['start_time'] = this.$moment(new Date(new Date()
									.getTime() - (30 * 24 * 60 * 60 * 1000))).format('YYYY-MM-DD');
								list.fixed_seo_data['end_time'] = this.$moment(new Date()).format(
									'YYYY-MM-DD')
							}
							// if (this.type.c_value.value == 'custom_cost_visit_list' ) {
							// 	item.options.initialValue = [this.$moment(new Date(new Date()
							// 			.getTime() - (7 * 24 * 60 * 60 * 1000)), 'YYYY/MM/DD'),
							// 		this
							// 		.$moment(new Date(), 'YYYY/MM/DD')
							// 	]
							// }
							if (this.type.c_value.value == 'customer_sales_volume' || this.type.c_value
								.value ==
								'customer_sales_comparison_goods' || this.type.c_value.value ==
								'customer_sales_comparison_cate') {
								item.options.initialValue = [this.$moment(new Date(), 'YYYY-MM-DD'),
									this.$moment(new Date(), 'YYYY-MM-DD')
								]

								list.fixed_seo_data['start_time'] = this.$moment(new Date()).format(
									'YYYY-MM-DD')
								list.fixed_seo_data['end_time'] = this.$moment(new Date()).format(
									'YYYY-MM-DD')
							}
							if (this.type.c_value.value == 'customer_sales_volume') {
								item.options.initialValue = [this.$moment(new Date(), 'YYYY-MM-DD'),
									this
									.$moment(new Date(), 'YYYY-MM-DD')
								]
								list.fixed_seo_data['start_time'] = this.$moment(new Date()).format(
									'YYYY-MM-DD')
								list.fixed_seo_data['end_time'] = this.$moment(new Date()).format(
									'YYYY-MM-DD')
							}

							if (this.type.c_value.value == 'custom_order_goods' || this.type.c_value
								.value ==
								'custom_order_checkout') {
								// 获取当前月份第一天
								const firstDay = new Date();
								firstDay.setDate(1);

								// 获取当前月份最后一天
								const lastDay = new Date();
								item.options.initialValue = [this.$moment(firstDay, 'YYYY-MM-DD'),
									this.$moment(lastDay, 'YYYY-MM-DD')
								]
								list.fixed_seo_data['start_time'] = this.$moment(firstDay).format(
									'YYYY-MM-DD')
								list.fixed_seo_data['end_time'] = this.$moment(new Date()).format(
									'YYYY-MM-DD')

							}


						}
					}
				});

				// 将列表中的“列”与现在设置的“字段设置”同步
				setTimeout(() => {
					list.set_columns();
				}, 1);
				// 该延时器用于覆盖 TableList 组件里 watch 中 columns 对 real_columns 的更新

				list.page = 1; // 切换维度后需要重新从第一页开始
				list.get_list();
				this.options_load(); // 获取筛选表单中的下拉数据
			},
			set_list() {
				let list = this.$refs.list;

				list.screen_columns.checked = this.type.c_value.selected_field; // 在“字段设置”弹窗中回显

				// 将列表中的“列”与现在设置的“字段设置”同步
				setTimeout(() => {
					list.set_columns();
				}, 1);
				// 该延时器用于覆盖 TableList 组件里 watch 中 columns 对 real_columns 的更新

				list.page = 1; // 切换维度后需要重新从第一页开始
				list.get_list();
			},
			// “请选择导出表格内容”发生改变
			type_change(event) {
				if (this.type.p_index == 5) {
					this.res_column()
				} else if (this.type.p_index == 7) {
					this.sales_column()
				}
				this.$refs.list.fixed_seo_data = {}

				this.set_list_payload();
			},
			get_quert() {
				if (JSON.stringify(this.$route.query) == '{}' || !this.$route.query.report_key) {
					return false;
				}
				let query = {}
				this.mapping.forEach(item => {
					if (item.report_key == this.$route.query.report_key) {
						item.data.forEach(item_sub => {
							if (this.$route.query[item_sub.old]) {
								if ((item_sub.new == "customer_type" || item_sub.new ==
										"order_status") &&
									this.$route.query[item_sub.old].indexOf(",") != -1 && (this
										.$refs.list
										.fixed_seo_data.export_type == 'custom_order_list' || this
										.$refs
										.list.fixed_seo_data.export_type ==
										'custom_order_distributor')) {
									let level_array = this.$route.query[item_sub.old].split(',');
									query[item_sub.new] = level_array[level_array.length - 1];
								} else {
									query[item_sub.new] = this.$route.query[item_sub.old];
								}
							}
						});
					}
				});
				return query;
			},
			// 铺市率的动态表头
			get_column(goods_id) {
				this.$method.get_goods_v2({
					data: {
						goods_ids: goods_id ? goods_id : null
					}
				}).then(res => {
					this.goods_list = res.data.list;
					res.data.list.forEach(item => {
						this.slot_table_list.push(item.id)
						let obj = {
							title: item.goods_title + ' | 铺市率',
							dataIndex: item.id,
							width: 200,
							cate_name: "none",
							scopedSlots: {
								customRender: item.id
							}
						}
						type_data[5].is_more = true
						type_data[5].children[0].children.push(obj)
						type_data[5].children[1].children.push(obj)
						type_data[5].children[1].selected_field.push(item.id)
						type_data[5].children[0].selected_field.push(item.id)

					})
					this.set_list()
				})
			},
			// “请选择您要输出的报表维度”发生改变
			parent_change(item, index) {
				this.type.p_index = index;
				//默认选中“导出表格内容”的第一个选项
				this.type.c_value = this.type.option[this.type.p_index].children[0];
				this.type_change() //执行选项选择后的调用方法
			},
		}
	}
</script>

<style lang="less">
	@import "../../assets/less/app.less";
	@import 'modify_report.less';

	.custom_cost_piles_box {
		display: flex;

		.custom_cost_piles_item {
			min-width: 100px;
			margin-right: 10px;
			font-size: 14px;

			span {
				color: #333;
				font-size: 16px;
				font-weight: 500;
			}
		}

		.custom_cost_piles_item2 {
			span {
				color: #52c41a;
			}
		}

		.custom_cost_piles_item3 {
			span {
				color: #faad14;
			}
		}
	}
</style>